import { APP_PAGES_NAMES } from './appPageNames';
import { APP_ROUTES } from './appRoutes';
import { WEB_ROUTES } from './webRoutes';

// конфигурация роутов для навигации в приложении на клиенте
export const APP_PAGES_CONFIG = {
  [APP_PAGES_NAMES.LOANS_RATES]: {
    app: APP_ROUTES.loansRates,
    web: WEB_ROUTES.loansRates,
  },
  [APP_PAGES_NAMES.LOANS_OFFERS]: {
    app: APP_ROUTES.loansOffers,
    web: WEB_ROUTES.loansOffers,
  },
  [APP_PAGES_NAMES.LOANS_OFFERS_RESTORE]: {
    app: APP_ROUTES.loansOffers,
    web: WEB_ROUTES.loansOffers,
  },
  [APP_PAGES_NAMES.WAYBACK_RESTORE]: {
    app: APP_ROUTES.loansOffers,
    web: WEB_ROUTES.wayback,
  },
  [APP_PAGES_NAMES.NEW_FORM]: {
    app: APP_ROUTES.newForm,
    web: WEB_ROUTES.creditForm,
  },
  [APP_PAGES_NAMES.NEW_FORM_RESTORE]: {
    app: APP_ROUTES.newForm,
    web: WEB_ROUTES.creditForm,
  },
  [APP_PAGES_NAMES.NEW_FORM_WL]: {
    app: APP_ROUTES.newFormWL,
    web: WEB_ROUTES.whiteLabel,
  },
  [APP_PAGES_NAMES.OBRAZOVANIE]: {
    app: APP_ROUTES.vitrins,
    web: WEB_ROUTES.obrazovanie,
  },
  [APP_PAGES_NAMES.IPHONEE]: {
    app: APP_ROUTES.vitrins,
    web: WEB_ROUTES.iphonee,
  },
  [APP_PAGES_NAMES.NALICHNYMI]: {
    app: APP_ROUTES.vitrins,
    web: WEB_ROUTES.nalichnymi,
  },
  [APP_PAGES_NAMES.BEZ_POSESHHENIJA_BANKA]: {
    app: APP_ROUTES.vitrins,
    web: WEB_ROUTES.bezPoseshhenijaBanka,
  },
  [APP_PAGES_NAMES.CREDIT_FULL_DEAL]: {
    app: APP_ROUTES.fullDeal,
    web: WEB_ROUTES.creditsFullDeal,
  },
  [APP_PAGES_NAMES.MARKETPLACE_SEO_LANDING]: {
    app: APP_ROUTES.vitrins,
    web: WEB_ROUTES.marketplaceSeoLanding,
  },
  [APP_PAGES_NAMES.COMPLETED_DEAL]: {
    app: APP_ROUTES.completedDeal,
    web: WEB_ROUTES.completedDeal,
  },
  [APP_PAGES_NAMES.LOANS_SEO_LANDING]: {
    app: APP_ROUTES.loansSeoLanding,
    web: WEB_ROUTES.loansSeoLanding,
  },
  [APP_PAGES_NAMES.CREDIT_CARDS_SEO_LANDING]: {
    app: APP_ROUTES.creditCardsSeoLanding,
    web: WEB_ROUTES.creditCardsSeoLanding,
  },
  [APP_PAGES_NAMES.PRODUCT_FORM]: {
    app: APP_ROUTES.productForm,
    web: WEB_ROUTES.productForm,
  },
  [APP_PAGES_NAMES.PRODUCT_STATUS]: {
    app: APP_ROUTES.productStatus,
    web: WEB_ROUTES.productStatus,
  },
  [APP_PAGES_NAMES.PRODUCT]: {
    app: APP_ROUTES.product,
    web: WEB_ROUTES.product,
  },
} as const;
